import api from '@/apis/ca/cAFundInventoryAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('cAFundInventory', api);

const state = {
  ...crud.state,
  _config: {
    table: 'ca_fund_inventory',
    field: {
      key: 'ref_id',
      code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
